<template>
  <v-container class="pt-0 mt-0" fluid>
    <v-row>
      <v-spacer />
      <v-col cols="11">
        <v-card class="mx-auto">
          <v-toolbar color="teal" dark class="text-xs-center">
            <v-toolbar-title style="color: white">{{ pageTitle }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details>
            </v-text-field>
          </v-toolbar>
        </v-card>
      </v-col>
      <v-spacer />
    </v-row>
    <v-row v-for="(linkType, i) in this.allLinks" :key="i">
      <v-spacer />
      <v-col cols="11">

        <v-data-table :headers="headers" :items="linkType.links" sort-by="linkText" class="elevation-1  table-striped"
          hide-default-footer disable-pagination must-sort calculate-widths dense :search="search">

          <template v-slot:top>
            <div class="card-row-header">
              <v-toolbar-title class="ma-2 pa-2">{{ linkType.linkTypeTitle }}</v-toolbar-title>
            </div>
            <p class="ma-2 pa-2" v-if="linkType.linkTypeDescription">
              {{ linkType.linkTypeDescription }}
            </p>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td>
                <b><a :href="item.link">{{ item.linkText }}</a></b>
              </td>
              <td>
                <v-icon v-if="item.isNew" large color="red"> mdi-new-box </v-icon>
                {{ item.linkDescription }}
              </td>
            </tr>
          </template>
        </v-data-table>

      </v-col>
      <v-spacer />

    </v-row>
  </v-container>
</template>

<script>
import serverFunctions from "@/functions/serverFunctions";
import userFunctions from "@/functions/userFunctions";

export default {
  name: "Links",
  computed: {
    pageTitle() {
      return this.$vuetify.breakpoint.smAndDown ? "EPS Links" : "The European Palm Society - Interesting Links";
    }
  },
  methods: {
    async getLinkData() {
      const getLinksRequest = serverFunctions.getDataRequestObject(userFunctions.getLoggedInUser());
      let result = await serverFunctions.getRawPostResponse("/getAllLinks", getLinksRequest);
      this.allLinks = result;
      userFunctions.updateLastViewed('links');
    },
    rowClass(item) {
      item
    }
  },
  data: () => ({
    allLinks: null,
    panel: 0,
    search: null,
    headers: [
      {
        text: "Link",
        align: "start",
        value: "linkText",
      },
      {
        text: "Description",
        align: "start",
        value: "linkDescription",
      },
    ],

  }),
  beforeMount() {
    this.getLinkData();
  },
};
</script>

<style scoped>
.palm-site-green {
  background-color: rgb(176, 217, 173);
}

.card-row-header {
  background-color: rgb(213, 230, 213) !important;
  color: #005050
}

.v-data-table .v-data-table__wrapper table tbody tr:nth-of-type(odd) {
  background-color: rgb(240, 246, 240) !important;
  /* color: #005050 */
}

.v-data-table .v-data-table__wrapper table tbody tr:nth-of-type(even) {
  color: #005050
}
</style>
